import styles from "./styles.module.css";
export const ContractTitle = ({ text }: any) => {
  return <div className={styles.title}>{text}</div>;
};
export const ContractSubTitle = ({ text }: any) => {
  return <div className={styles.subTitle}>{text}</div>;
};
export const ContractDescription = ({ text }: any) => {
  return <div className={styles.description}>{text}</div>;
};
export const ContractDateAndNumber = ({ text }: any) => {
  return <div className={styles.dateAndNumber}>{text}</div>;
};
